import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import { SEO } from '../seo/SEO';

export function NotFoundPage() {
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <section className="max-w-editorial mx-auto px-6 sm:px-10 py-24 sm:py-32">
      <SEO titleKey="seo.notFound.title" descriptionKey="seo.notFound.description" noindex />
      <div className="grid grid-cols-12 gap-6 items-end">
        <div className="col-span-12 md:col-span-2 reveal reveal-delay-1">
          <span className="editorial-number text-7xl leading-none">404</span>
          <div className="mt-3 editorial-label">{t('notFound.kicker')}</div>
        </div>

        <div className="col-span-12 md:col-span-8 reveal reveal-delay-2">
          <h1 className="font-display text-[clamp(2.5rem,6vw,5rem)] leading-[0.95] tracking-tight text-ink">
            <span className="block">{t('notFound.titleLine1')}</span>
            <span className="block italic text-brass">{t('notFound.titleLine2')}</span>
          </h1>
          <p className="font-body text-base text-ink-soft leading-relaxed mt-8 max-w-prose">
            {t('notFound.subtitle')}
          </p>
          <p className="font-body text-sm text-ash mt-4 break-all">
            <span className="editorial-label me-2">{t('notFound.requestedPath')}</span>
            <code>{location.pathname}</code>
          </p>
        </div>

        <div className="col-span-12 md:col-span-2 reveal reveal-delay-3">
          <div className="editorial-rule mb-4" />
          <Link
            to="/"
            className="editorial-label text-ink hover:text-brass inline-flex items-center gap-2"
          >
            <ArrowLeft className="w-3.5 h-3.5" />
            {t('notFound.backHome')}
          </Link>
        </div>
      </div>

      <div className="mt-20 pt-10 border-t border-linen grid grid-cols-1 sm:grid-cols-3 gap-6">
        <Link to="/" className="brass-link editorial-label">
          → {t('notFound.suggestions.catalog')}
        </Link>
        <Link to="/about" className="brass-link editorial-label">
          → {t('notFound.suggestions.about')}
        </Link>
        <Link to="/contact" className="brass-link editorial-label">
          → {t('notFound.suggestions.contact')}
        </Link>
      </div>
    </section>
  );
}
